import React from 'react';
import { Navigate, Route, useParams } from 'react-router-dom';

import DocsLayout from './DocsLayout';
import { docsSection } from '../../config/routeHandles';

// Every page is its own chunk: the portal is reference material, and nobody
// adding an item should pay for the guides' index.
const DocsHome = React.lazy(() => import('./DocsHome'));
const DocsSection = React.lazy(() => import('./DocsSection'));
const DocsGuide = React.lazy(() => import('./DocsGuide'));
const DocsWhatsNew = React.lazy(() => import('./DocsWhatsNew'));
const ShowcaseList = React.lazy(() => import('./ShowcaseList'));

// An atlas bookmarked under /docs keeps its atlas.
function AtlasRedirect() {
	const { atlasKey } = useParams();
	return <Navigate to={`/admin/atlases/${encodeURIComponent(atlasKey)}`} replace />;
}

/**
 * The /docs portal route fragment — a fragment of <Route> elements for the
 * same reason adminRoutes() is one: src/index.js and the routing tests share
 * the real configuration.
 *
 * Everything here is for everyone, signed in or not: the guides read static
 * files, and What's new reads nothing at all (docs/ARCHITECTURE.md, "The
 * documentation portal"). How keepr is BUILT — the atlases, the engineering
 * change log and the line counts — is in the admin portal (adminRoutes.js);
 * their old paths here forward there, behind its guard.
 */
export default function docsRoutes() {
	return (
		<React.Fragment>
			<Route path='docs' element={<DocsLayout />}>
				<Route index element={<DocsHome />} handle={docsSection('guides')} />
				<Route path='guides/:section' element={<DocsSection />} handle={docsSection('guides')} />
				<Route path='guides/:section/:slug' element={<DocsGuide />} handle={docsSection('guides')} />
				<Route path='whats-new' element={<DocsWhatsNew />} handle={docsSection('whats-new')} />
				{/* Every video keepr shows (KPR-1923): public, prerendered, its address permanent. */}
				<Route path='showcase' element={<ShowcaseList />} handle={docsSection('showcase')} />
			</Route>

			{/* Moved to the admin portal; bookmarks follow. */}
			<Route path='docs/atlases' element={<Navigate to='/admin/atlases' replace />} />
			<Route path='docs/atlases/:atlasKey' element={<AtlasRedirect />} />
			<Route path='docs/changelog' element={<Navigate to='/admin/changelog' replace />} />
			<Route path='docs/codebase' element={<Navigate to='/admin/codebase' replace />} />
		</React.Fragment>
	);
}
